import React from 'react'
import { Box, IconButton, TableCell, TableRow, Typography, useMediaQuery } from '@mui/material'
import EyeIcon from "../../common/assests/eyegreen.png";
import DeletIcon from "../../common/assests/deleticon.png";
import CompanyLogo from "../../common/assests/reyleafLogo.svg";
import configuration from '../../config/Config';

const VenderAllProductRow = ({item,deleteItem,viewMore,StarRatingComponent }) => {
    const isSmallScreen = useMediaQuery("(max-width:480px)");
  return (
    <TableRow
    key={item?._id}
    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
  >
    <TableCell>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={
            item?.photos && item.photos.length > 0
              ? `${configuration.cdnFront}/${item.photos[0].url}`
              : CompanyLogo
          }
          alt={item?.title||"img"}
          style={{
            height: "50px",
            width: "50px",
            marginRight: "8px",
            borderRadius: "50%",
          }}
        />
      </Box>
    </TableCell>
    <TableCell>
      <Box sx={{ display: "flex", alignItems: "center",whiteSpace:'nowrap' }}>
        <Typography>{item?.title || "-"}</Typography>
      </Box>
    </TableCell>
    <TableCell>{item?.categoryId?.name || "-"}</TableCell>
    <TableCell sx={{whiteSpace:'nowrap'}}>{item?.description || "-"}</TableCell>
    {/* <TableCell>{item?.paymentStatus||"-"}</TableCell> */}
    <TableCell>
      <StarRatingComponent rating={item?.rating || "0"} />

      {item?.rating
        ? parseFloat(item?.rating).toFixed(2)
        : "0"}
    </TableCell>
    <TableCell>{`$${item?.price || "-"}`}</TableCell>

    <TableCell>{`$${item?.discountedProce || "-"
      }`}</TableCell>
    <TableCell>{item?.status || "-"}</TableCell>
    <TableCell sx={{display:'flex'}}>
      <IconButton onClick={viewMore}>
        <img
          src={EyeIcon}
          alt="viewicon"
          style={{
            height: isSmallScreen ? "35px" : "45px",
            width: isSmallScreen ? "35px" : "45px",
          }}
        />
      </IconButton>

      <IconButton onClick={deleteItem}>
        <img
          src={DeletIcon}
          alt="DeletIcon"
          style={{
            height: isSmallScreen ? "35px" : "45px",
            width: isSmallScreen ? "35px" : "45px",
          }}
        />
      </IconButton>
    </TableCell>
  </TableRow>
  )
}

export default VenderAllProductRow